import { render, staticRenderFns } from "./ClassroomModal.vue?vue&type=template&id=a4cff506"
import script from "./ClassroomModal.vue?vue&type=script&lang=js"
export * from "./ClassroomModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports